/**
 * @generated SignedSource<<79a1009193c3cc09d7e871ae1050f318>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyRespTopNavFilters_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbRespRefineMenuFilterDimensions_user" | "SbRespRefineMenuFilterPrice_user">;
  readonly " $fragmentType": "BuyRespTopNavFilters_user";
};
export type BuyRespTopNavFilters_user$key = {
  readonly " $data"?: BuyRespTopNavFilters_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyRespTopNavFilters_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyRespTopNavFilters_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterPrice_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterDimensions_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "a3537f2d7cf46d23b4e59cd517eeddf3";

export default node;
